const en = {
  // Navbar
  nav_contact: 'Contact',
  nav_cta: 'Get Started',

  // Footer
  footer_tagline: "re.scoop is the AI inbox built for creators.\nIt helps turn fan and brand messages into momentum.",
  footer_product: 'Product',
  footer_company: 'Company',
  footer_how_it_works: 'How It Works',
  footer_use_cases: 'Use Cases',
  footer_trust: 'Trust & Control',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Service',
  footer_copyright: '© 2026 iconX Inc. All rights reserved.',

  // Problem Section
  problem_card_brand: "Brand proposals shouldn't live in the abyss of your DMs.",
  problem_card_fan: 'Real fan love keeps getting pushed down by the algorithm.',
  problem_card_link: 'Link requests are scattered across every platform you use.',
  problem_card_spam: 'Spam and hate messages are cluttering your workspace.',
  problem_headline_1: 'The important stuff is always',
  problem_headline_2: 'at the bottom.',
  problem_sub: "Somewhere between notification #1 and notification #847, the message that could change your week is slowly disappearing. That's where re.scoop steps in.",
  problem_notif_unread: 'Unread',

  // Trust
  trust_headline_1: 'AI ranks.',
  trust_headline_2: 'You decide.',
  trust_headline_3: '',
  trust_c1_title: 'AI sorts.\nYou send.',
  trust_c1_desc: "re.scoop never auto-sends anything. It just classifies and prioritizes so you know what's waiting.",
  trust_c2_title: 'Your data stays\nyours.',
  trust_c2_desc: "We don't train external models, serve ads, or share your messages with anyone. Ever.",
  trust_c3_title: 'Zero suspension\nrisk.',
  trust_c3_desc: "No shady automation. re.scoop is designed to help you write real replies, not fake ones.",

  // Final CTA
  final_headline_1: 'Never miss',
  final_headline_2: 'a deal',
  final_headline_3: 'again.',
  final_sub: "Start light with YouTube comments and Gmail. re.scoop will dig up the brand and fan messages that actually deserve your time.",
  final_cta: 'Start Rescooping',
  final_contact: 'Talk to the Team',
  final_trust_1: 'Free plan available',
  final_trust_2: 'Privacy first',
  final_trust_3: 'One-click Google connect',

};

export default en;
